import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Medicine/GetDetail?` + params, null);

export const GetMedicineList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Medicine/GetList?` + params, null);

export const CreateMedicine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Medicine/Create`, data);

export const UpdateMedicine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Medicine/Update`, data);

export const DeleteMedicine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Medicine/Delete`, data);

export const CreateMedicineDoseMedicine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Medicine/CreateMedicineDoseMedicine`, data);

export const CreatePreviousMedicine = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Medicine/CreatePreviousMedicine`, data);
